// Warning: this will be re-generated on CI server
export const APP_VERSION: string = "1.1.7";
export const APP_BUILD_NUMBER: string = "4899";
export const APP_BUILD_TIME: number = 1793798010736;
export const APP_GIT_COMMIT: string = "b72b8ef2";
export const APP_GIT_BRANCH: string = "develop";
